export default __webpack_public_path__ + "static/media/aiText2.c43fb494.png";